import { useEffect } from "react";
import styled from "styled-components";
import { theme } from "../../helpers/theme";

interface IconProps {
  icon: JSX.Element | string;
  width?: string;
  height?: string;
  rotate?: number;
  displayNone?: boolean;
  displayNoneSize?: string;
  noPadding?: boolean;
}

const Icon = ({
  icon,
  width,
  height,
  rotate,
  displayNone,
  displayNoneSize,
  noPadding,
}: IconProps) => {
  return (
    <IconContainer
      width={width}
      height={height}
      rotate={rotate}
      displayNone={displayNone}
      displayNoneSize={displayNoneSize}
      noPadding={noPadding}
    >
      {icon}
    </IconContainer>
  );
};

export default Icon;

const IconContainer = styled.div<{
  width?: string;
  height?: string;
  rotate?: number;
  displayNone?: boolean;
  displayNoneSize?: string;
  noPadding?: boolean;
}>`
  height: ${(props: any) => props?.height && props.height};
  width: ${(props: any) => props?.width && props.width};
  display: ${(props: any) => (props?.displayNone ? "none" : "flex")}!important;
  align-items: center;
  justify-content: center;
  ${({ rotate }: any) => rotate && `transform: rotate(${rotate}deg);`}
  ${(props: any) =>
    props?.displayNoneSize
      ? ` 
      @media ${props.displayNoneSize}{
      display:none !important;
      } `
      : ` `};
  > svg,
  img {
    box-sizing: border-box;
    height: ${(props: any) => props?.height ? props.height : "100%"};
    width: ${(props: any) => props?.width ? props.width : "100%"};
    padding: ${(props: any) => (props?.noPadding ? "none" : "10px")};
  }
`;
